<ng-container *ngIf="planActivationSummary$ | async as summary; else loading">
  <div class="container-fluid py-4 subscription-page">
    <div class="subscription-wrapper">
      <!-- TOP HEADER -->

      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 class="fw-bold mb-1">Review your subscription</h2>

          <p class="text-muted mb-0">Scale your team workspace limits before checkout.</p>
        </div>

        <!-- <div class="billing-toggle">
          <button>Monthly</button>

          <button class="active">
            Yearly

            <span> SAVE 20% </span>
          </button>
        </div> -->
      </div>

      <div class="row g-4">
        <!-- LEFT SECTION -->

        <div class="col-xl-8">
          <div class="card subscription-card">
            <div class="card-body">
              <!-- PLAN HEADER -->

              <div class="d-flex justify-content-between align-items-start">
                <div class="d-flex">
                  <div class="plan-icon">
                    <i class="ti ti-briefcase"></i>
                  </div>

                  <div class="ms-3">
                    <div class="d-flex align-items-center gap-2">
                      <h3 class="mb-1">
                        {{ summary.plan.name }}
                      </h3>

                      <span class="best-value"> BEST VALUE </span>
                    </div>

                    <p class="text-muted mb-0">
                      <i class="ti ti-calendar"></i>

                      Next billing date is

                      {{ summary.plan.nextBillingDate | date: 'mediumDate' }}
                    </p>
                  </div>
                </div>

                <div class="price-section text-end">
                  <!-- <h1 class="price">
                    {{
                      summary.plan.discountedPrice
                        | currency: summary.billingSummary.currency : 'symbol' : '1.0-0'
                    }}
                  </h1>

                  <span class="text-muted"> / user / mo </span> -->

                  <div class="price-row">
                    <h1 class="price">
                      {{
                        summary.plan.discountedPrice
                          | currency: summary.billingSummary.currency : 'symbol' : '1.0-0'
                      }}
                    </h1>

                    <span class="text-muted"> / user </span>
                  </div>
                  <div>
                    <span class="discount"
                      ><span class="old-price"> ₹{{ summary.plan.price.toFixed(2) }} </span>
                      <!-- 50% Off Applied -->
                    </span>
                  </div>
                </div>
              </div>

              <hr />

              <!-- LICENSE SECTION -->

              <div class="mt-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h5 class="mb-0">Assign Plan Licenses</h5>

                  <span class="text-muted"> 1 seat = 1 active workspace member </span>
                </div>

                <div class="row align-items-center">
                  <div class="col-md-6">
                    <div class="license-box">
                      <button
                        class="step-btn"
                        (click)="onLicenceChange(-1, summary.plan.minimumLicences)"
                        [disabled]="licenceCount <= summary.plan.minimumLicences"
                      >
                        <i class="ti ti-minus"></i>
                      </button>

                      <!-- <input
                        type="number"
                        [(ngModel)]="licenceCount"
                        (input)="onLicenceInput($event, summary.plan.minimumLicences)"
                        [style.width]="((licenceCount || 0).toString().length || 1) + 2 + 'ch'"
                        [min]="summary.plan.minimumLicences"
                      /> -->

                      <input
                        type="number"
                        [(ngModel)]="licenceCount"
                        (input)="onLicenceInput($event)"
                        (blur)="onLicenceBlur($event, summary.plan.minimumLicences)"
                        [style.width]="((licenceCount || 0).toString().length || 1) + 2 + 'ch'"
                        [min]="summary.plan.minimumLicences"
                      />

                      <button
                        class="step-btn"
                        (click)="onLicenceChange(1, summary.plan.minimumLicences)"
                      >
                        <i class="ti ti-plus"></i>
                      </button>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="license-info">
                      <i class="ti ti-info-circle"></i>

                      Licenses can be scale-adjusted up or down natively via billing controls
                      anytime.
                    </div>
                  </div>
                </div>

                <div class="calculation mt-4">
                  <span> Current Calculation: </span>

                  <strong>
                    {{ licenceCount }} users ×

                    {{
                      summary.billingSummary.planProratedCharge
                        | currency: summary.billingSummary.currency
                    }}

                    =

                    {{
                      licenceCount * summary.billingSummary.planProratedCharge
                        | currency: summary.billingSummary.currency
                    }}

                    / month
                  </strong>
                </div>
              </div>
            </div>
          </div>

          <!-- FEATURES -->

          <div class="row mt-4 g-3">
            <div class="col-md-6">
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="ti ti-lock"></i>
                </div>

                <div>
                  <h5>Secure Payments</h5>

                  <p>256-bit SSL encrypted transit protocols.</p>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="ti ti-adjustments"></i>
                </div>

                <div>
                  <h5>Flexible Licensing</h5>

                  <p>Cancel or add seats without dynamic penalties.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT ORDER -->

        <div class="col-xl-4">
          <div class="card order-card">
            <div class="card-body">
              <h5 class="fw-bold">ORDER BREAKDOWN</h5>

              <div class="promo-title mt-4">
                <span class="promo-label"> PROMO CODE </span>

                <span class="gift-text text-primary"> Have a gift card? </span>
              </div>

              <div class="input-group mt-2">
                <input class="form-control" placeholder="SUMMER50" [(ngModel)]="couponCode" />

                <button class="btn btn-dark" (click)="applyCoupon()">Apply</button>
              </div>

              <hr class="my-4" />

              <div class="summary-row">
                <span> Base Unit Rate </span>

                <strong>
                  {{
                    summary.billingSummary.planProratedCharge
                      | currency: summary.billingSummary.currency
                  }}

                  / seat
                </strong>
              </div>

              <div class="summary-row">
                <span> Allocated Seats </span>

                <strong>
                  {{ licenceCount }}
                </strong>
              </div>

              <div class="summary-row">
                <span> License Amount </span>

                <strong>
                  {{
                    summary.billingSummary.planProratedCharge * summary.plan.requestedLicences
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                </strong>
              </div>

              <div class="summary-row" *ngIf="summary.billingSummary.couponDiscount > 0">
                <span> Coupon Discount </span>

                <strong>
                  -
                  {{
                    summary.billingSummary.couponDiscount
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                </strong>
              </div>

              <div class="summary-row">
                <span> Subtotal Amount </span>

                <strong>
                  {{
                    summary.billingSummary.taxableAmount | currency: summary.billingSummary.currency
                  }}
                </strong>
              </div>

              <div class="summary-row">
                <span> Integrated GST ({{ summary.billingSummary.gstRate }}%) </span>

                <strong>
                  {{ summary.billingSummary.gstAmount | currency: summary.billingSummary.currency }}
                </strong>
              </div>

              <hr />

              <div class="summary-total">
                <span> Total Due </span>

                <strong>
                  {{
                    summary.billingSummary.amountToBePaid
                      | currency: summary.billingSummary.currency
                  }}
                </strong>
              </div>

              <p class="terms-text">
                By moving forward, you explicitly agree to our immediate proration Terms of Service.
              </p>

              <!-- Autopay opt-in — sirf monthly plans ke liye relevant hai -->
              <div
                class="form-check mt-3"
                *ngIf="summary.plan.billingFrequency?.toLowerCase() === 'monthly'"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="wantsAutopay"
                  [(ngModel)]="wantsAutopay"
                />
                <label class="form-check-label" for="wantsAutopay">
                  Enable Autopay for future renewals
                  <small class="d-block text-muted">
                    You'll be asked to authorize auto-debit right after this payment.
                  </small>
                </label>
              </div>

              <button class="btn btn-orange w-100" (click)="activateSubscription()">
                Complete Secure Purchase

                <i class="ti ti-arrow-right ms-2"></i>
              </button>

              <div class="security mt-4">
                <span>
                  <i class="ti ti-shield-check"></i>
                  PCI-DSS COMPLIANT
                </span>

                <span>
                  <i class="ti ti-lock"></i>
                  SSL ENCRYPTED
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="d-flex justify-content-center align-items-center p-5"></div>
</ng-template>
